import React, { useState, useEffect } from 'react';
import '../styles/theme.css';

const navItems = ['About', 'Experience', 'Education', 'Projects', 'Certifications', 'Contact'];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id.toLowerCase())?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav className={scrolled ? 'navbar scrolled' : 'navbar'}>
      <a href="#hero" className="logo">
        MB
      </a>

      <button
        type="button"
        className={menuOpen ? 'menu-toggle is-open' : 'menu-toggle'}
        aria-label="Toggle navigation"
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen((open) => !open)}
      >
        <span />
        <span />
        <span />
      </button>

      <ul className={menuOpen ? 'links is-open' : 'links'}>
        {navItems.map((item) => (
          <li key={item}>
            <span
              className="link"
              onClick={() => scrollTo(item)}
            >
              {item}
            </span>
          </li>
        ))}
      </ul>
    </nav>
  );
}
